/* =================================================================
   D3X Affiliates — interactions
   - Scroll reveal
   - Sticky CTA (hide near final)
   - Commission calculator (slider + live outputs + milestone context)
   - FAQ accordion
   ================================================================= */

(function () {
  var root = document.querySelector('.d3x-root');
  if (!root) return;

  /* ---- Scroll reveal ----------------------------------------- */
  try {
    if ('IntersectionObserver' in window) {
      root.classList.add('js-reveal');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

      root.querySelectorAll('.reveal, .reveal-d1, .reveal-d2, .reveal-d3').forEach(function (el) {
        io.observe(el);
      });

      setTimeout(function () {
        root.querySelectorAll('.reveal:not(.in), .reveal-d1:not(.in), .reveal-d2:not(.in), .reveal-d3:not(.in)').forEach(function (el) {
          el.classList.add('in');
        });
      }, 2800);
    }
  } catch (e) { root.classList.remove('js-reveal'); }

  /* ---- Sticky CTA hide near final section -------------------- */
  try {
    var sticky  = root.querySelector('#d3x-stickyCta');
    var finalEl = root.querySelector('#d3x-finalSection');
    if (sticky && finalEl && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('hidden', e.isIntersecting);
        });
      }, { threshold: 0.2 });
      sio.observe(finalEl);
    }
  } catch (e) {}

  /* ---- Commission calculator --------------------------------- */
  try {
    var slider  = root.querySelector('#d3x-slider');
    var dispNum = root.querySelector('#d3x-disp-num');
    var monthly = root.querySelector('#d3x-monthly');
    var annual  = root.querySelector('#d3x-annual');
    var context = root.querySelector('#d3x-calc-context');

    // Average commission per active subscriber per month
    // Weighted blend: ~60% 1-mo sub ($4.08), ~30% 3-mo sub ($3.36/mo), ~10% one-time ($4.68)
    var PER_SUB = 3.90;
    var MIN = 10, MAX = 500;

    var milestones = [
      { at: 10,  text: "That's your Spotify, Netflix, and gym membership. Every month." },
      { at: 25,  text: "That's a nice dinner out. Every month, without thinking about it." },
      { at: 50,  text: "That's your phone bill covered. Automatically." },
      { at: 100, text: "That's a car payment. From referrals you made once." },
      { at: 200, text: "That's a rent contribution. Running in the background." },
      { at: 350, text: "That's a part-time salary. From one product." },
      { at: 500, text: "That's $23K a year. From referrals you already sent." }
    ];

    function getContext(n) {
      var line = milestones[0].text;
      for (var i = 0; i < milestones.length; i++) {
        if (n >= milestones[i].at) line = milestones[i].text;
      }
      return line;
    }

    function clamp(n) { return Math.min(MAX, Math.max(MIN, isNaN(n) ? MIN : n)); }
    function fmt(n) {
      var v = Math.round(n);
      return '$' + (v >= 1000 ? (v / 1000).toFixed(1).replace('.0', '') + 'K' : v.toLocaleString('en-US'));
    }
    function flash(el) {
      if (!el) return;
      el.classList.add('flash');
      clearTimeout(el._ft);
      el._ft = setTimeout(function () { el.classList.remove('flash'); }, 240);
    }
    function update(n, source) {
      n = clamp(parseInt(n, 10));
      var m = n * PER_SUB;
      var y = m * 12;
      if (source !== 'slider' && slider) slider.value = n;
      if (dispNum) { dispNum.textContent = n; flash(dispNum); }
      if (monthly) { monthly.textContent = fmt(m); flash(monthly); }
      if (annual)  { annual.textContent  = fmt(y); flash(annual); }
      if (context) { context.textContent = getContext(n); }
    }

    if (slider) {
      slider.min = MIN;
      slider.max = MAX;
      slider.value = 50;
      slider.addEventListener('input', function () { update(slider.value, 'slider'); });
      update(50, 'both');
    }
  } catch (e) {}

  /* ---- FAQ accordion ----------------------------------------- */
  try {
    root.querySelectorAll('.faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        if (!item) return;
        var willOpen = !item.classList.contains('open');
        item.closest('.faq').querySelectorAll('.faq-item.open').forEach(function (o) {
          if (o !== item) {
            o.classList.remove('open');
            o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('open', willOpen);
        btn.setAttribute('aria-expanded', String(willOpen));
      });
    });
  } catch (e) {}

})();
